/* eslint-disable import/no-default-export */
import React, { ButtonHTMLAttributes } from 'react';

import classNames from 'classnames';

import { TestId } from '@trello/test-ids';
import Icon, { IconColor, IconName } from 'app/common/components/controls/icon';
import forwardRefComponent from 'app/common/lib/util/forward-ref-component';
import styles from './CloseButton.less';

interface CloseButtonProps {
  className?: string;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  color?: IconColor;
  quiet?: boolean;
  large?: boolean;
  medium?: boolean;
  onClick: React.EventHandler<React.MouseEvent<HTMLElement>>;
  small?: boolean;
  style?: React.CSSProperties;
  testId?: TestId;
}

export const CloseButton = forwardRefComponent<
  HTMLButtonElement,
  CloseButtonProps
>(
  'CloseButton',
  (
    {
      className,
      type,
      color,
      large = false,
      medium = false,
      onClick,
      small = false,
      quiet = false,
      style,
      testId,
    },
    ref,
  ) => (
    <button
      className={classNames(styles.closeButton, className)}
      onClick={onClick}
      style={style}
      ref={ref}
      data-test-id={testId}
      type={type}
    >
      <Icon
        color={color}
        large={large}
        medium={medium}
        name={IconName.Close}
        small={small}
        quiet={quiet}
      />
    </button>
  ),
);
